// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Informations_wrapper__18wFE","complexity":"Informations_complexity__yUUQK"};